<template>
    <div class="desk overscroll-none" @scroll="onscroll" id="desk">
        <div class="dates">
            <DateInterval
                :start="date.start" 
                :length="date.length" 
                :scale="scale" 
                :zero="zero" 
                :visibleLeft="position"
                v-for="date in panchanga.dates" 
                :key="date.start" 
            />
            <DateDummy :scale="scale" v-if="! canUse('panchanga-details-unlimited')" />
        </div>
        <div class="h-8"></div>
        <div class="intervals">
            <Vara 
                v-for="vara in panchanga.varas" :key="vara.start"
                :vara="vara" 
                :scale="scale" :zero="zero" :visibleLeft="position" :timezone="timezone"
            />
        </div>
        <div class="intervals">
            <Tithi 
                v-for="tithi in panchanga.tithis" :key="tithi.start"
                :tithi="tithi" 
                :scale="scale" :zero="zero" :visibleLeft="position" :timezone="timezone"
            />
        </div>
        <div class="intervals">
            <Nakshatra 
                v-for="nakshatra in panchanga.nakshatras" :key="nakshatra.start"
                :nakshatra="nakshatra" 
                :scale="scale" :zero="zero" :visibleLeft="position" :timezone="timezone"
            />
        </div>
        <div class="intervals">
            <Karana 
                v-for="karana in panchanga.karanas" :key="karana.start"
                :karana="karana" 
                :scale="scale" :zero="zero" :visibleLeft="position" :timezone="timezone"
            />
        </div>
        <div class="intervals">
            <Yoga 
                v-for="yoga in panchanga.yogas" :key="yoga.start"
                :yoga="yoga" 
                :scale="scale" :zero="zero" :visibleLeft="position" :timezone="timezone"
            />
        </div>
    </div>
</template>

<script>
import Vara from '@/components/panchanga/Vara'
import Tithi from '@/components/panchanga/Tithi'
import Nakshatra from '@/components/panchanga/Nakshatra'
import Karana from '@/components/panchanga/Karana'
import Yoga from '@/components/panchanga/Yoga'
import DateInterval from '@/components/panchanga/Date'
import DateDummy from '@/components/panchanga/DateDummy'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { Vara, Tithi, Nakshatra, Karana, Yoga, DateInterval, DateDummy },
  mixins: [TimeFormatMixin],
  data() {
    return {
        zero: undefined,
        position: 0,
        scale: 200,
        desk: undefined,
        timezone: undefined,
        preloadOffset: 200,
        dates: [],
    }
  },
  created() {
    this.setDay()
        .then(() => {
            this.zero = this.panchangaZero
            this.scrollToTime(this.current.day)
        })
  },
  mounted() {
    this.desk = document.getElementById("desk") || document.body

    this.scale = 86400 / this.desk.clientWidth

    if (this.scale < 200) 
        this.scale = 200
  },
  methods: {
    setDay() {
      return this.$store.dispatch('predictions/setCurrentDay', this.$route.params.day)
    },
    onscroll(event) {
        this.position = event.target.scrollLeft
        this.$store.dispatch('predictions/setCurrentDay', new Date(this.timestamp * 1000))
    },
    scrollToTime(time) {
        setTimeout(() => {
            document.getElementById('desk').scrollLeft = (time.getTime() / 1000 - this.zero) / this.scale - document.body.clientWidth / 2
        }, 100)
    },
    extendScrollToLeft() {
        // console.log('scroll')
        setTimeout(() => {
            document.getElementById('desk').scrollLeft = (this.zero - this.panchangaZero) / this.scale + this.position
            this.zero = this.panchangaZero
        }, 50)
    },
    updateScale() {
        if (this.panchanga.dates.length > 0 && this.panchanga.dates.length < 3 && this.scale == 200) {
            var lastDay = this.panchanga.dates[this.panchanga.dates.length - 1]
            this.scale = (lastDay.start + lastDay.length - this.panchanga.dates[0].start) / this.desk.clientWidth
        }
    },
  },
  computed: {
    time() {
        return this.formatTime(this.timestamp, 'H:i')
    },
    timestamp() {
        return this.zero + (this.position + document.body.clientWidth / 2) * this.scale
    },
    ...mapState('predictions', ['panchanga', 'current']),    
    ...mapGetters('predictions', ['panchangaZero']),    
    ...mapGetters('auth', ['canUse']),
  },
  watch: {
    '$route': 'setDay',
    'panchangaZero': 'extendScrollToLeft',
    'panchanga.dates': 'updateScale',
  },
}
</script>
